import apiService from '../api';
import type { ApiService } from '../api';

export interface RecoveryMessage {
  id: number;
  active: boolean;
  days: string;
  description: string;
  text: string;
  title: string;
  quantity?: number;
  opened?: number;
  clicked?: number;
}

class RecoveryMessagesService {
  constructor(private apiService: ApiService) {}

  public list(productId: number): Promise<any> {
    return this.apiService.get(`products/${productId}/recoveryemails`).toPromise();
  }

  public update(productId: number, messageId: number, data: Partial<RecoveryMessage>): Promise<any> {
    return this.apiService.put(`products/${productId}/recoveryemails/${messageId}`, data).toPromise();
  }

  public create(productId: number, data: Omit<RecoveryMessage, 'id'>): Promise<any> {
    return this.apiService.post(`products/${productId}/recoveryemails`, data).toPromise();
  }

  public listProductsSales(): Promise<any> {
    return this.apiService.get('reports/products', { producer_only: true }).toPromise();
  }
}

const recoveryMessagesService = new RecoveryMessagesService(apiService);
export default recoveryMessagesService;
